import React from "react";
import { Text } from "@fluentui/react-components";

export const RichText = ({ blocks }: { blocks: any }) => {
  if (!blocks || !Array.isArray(blocks)) return null;

  const renderInline = (children: any[]) => {
    return children.map((child, idx) => {
      if (!child.text) return null;

      let style: React.CSSProperties = {};

      if (child.bold) style.fontWeight = "bold";
      if (child.italic) style.fontStyle = "italic";
      if (child.underline) style.textDecoration = "underline";

      return (
        <span key={idx} style={style}>
          {child.text}
        </span>
      );
    });
  };

  return (
    <>
      {blocks.map((block, i) => {

        // Paragraphs
        if (block.type === "paragraph") {
          const hasText = block.children?.some(
            (c: any) => c.text && c.text.trim().length > 0
          );

          if (!hasText) {
            return <div key={i} style={{ height: "1rem" }} />; // controlled spacing
          }

          return (
            <Text key={i} size={400} block>
              {renderInline(block.children)}
            </Text>
          );
        }

        // Headings (h1–h6)
        if (block.type === "heading") {
          const level = block.level ?? 2;
          const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;

          return (
            <HeadingTag key={i} style={{ margin: "12px 0 4px" }}>
              <Text size={500} weight="semibold">
                {renderInline(block.children)}
              </Text>
            </HeadingTag>
          );
        }

        // Unordered list
        if (block.type === "list" && block.format === "unordered") {
          return (
            <ul key={i} style={{ marginTop: "8px", marginBottom: "8px" }}>
              {block.children?.map((li: any, idx: number) => (
                <li key={idx}>
                  <Text size={400}>{renderInline(li.children)}</Text>
                </li>
              ))}
            </ul>
          );
        }

        // Ordered list
        if (block.type === "list" && block.format === "ordered") {
          return (
            <ol key={i} style={{ marginTop: "8px", marginBottom: "8px" }}>
              {block.children?.map((li: any, idx: number) => (
                <li key={idx}>
                  <Text size={400}>{renderInline(li.children)}</Text>
                </li>
              ))}
            </ol>
          );
        }

        return null;
      })}
    </>
  );
};
